import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Layout from '../Layout/Layout';
import Header from '../Header/Header';
import styles from './PageLayout.module.css';

// 1. Define que o componente aceita essas funções
interface PageLayoutProps {
  onCartClick: () => void;
  onAccountClick: () => void;
}

function getTitle(pathname: string): string {
  if (pathname.startsWith('/admin')) return 'Admin';
  switch (pathname) {
    case '/': return 'Home';
    case '/kits': return 'Kits';
    case '/plugins': return 'Plugins';
    case '/shop': return 'Shop';
    case '/about': return 'About';
    default: return 'CLYDES';
  }
}

// 2. Recebe as funções aqui nos argumentos
const PageLayout: React.FC<PageLayoutProps> = ({ onCartClick, onAccountClick }) => {
  const location = useLocation();
  const title = getTitle(location.pathname);

  return (
    <Layout>
      {/* 3. REPASSA AS FUNÇÕES PARA O HEADER (Se faltar isso, não funciona!) */}
      <Header
        title={title}
        onCartClick={onCartClick}
        onAccountClick={onAccountClick}
      />
      <div className={styles.contentWrapper}>
        <Outlet />
      </div>
    </Layout>
  );
};

export default PageLayout;